import {useEffect, useState} from 'react';

const useAutocompleteDebounce = (value: string, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const immediate = value.length - debouncedValue.length >= 3;

    const timer = setTimeout(
      () => setDebouncedValue(value),
      immediate ? 0 : delay
    );

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return [debouncedValue, setDebouncedValue] as const;
};

export default useAutocompleteDebounce;
